'use es6';

import Immutable from 'immutable';
import { cleanObject } from '../utils/formatters';
import BusinessHour from './BusinessHour';
const EMPTY_LIST = Immutable.List();
const defaults = {
  answers: EMPTY_LIST,
  responseTime: null,
  timezone: '',
  hours: EMPTY_LIST
};
export default class SupportInfo extends Immutable.Record(defaults) {
  constructor(json = {}) {
    const values = JSON.parse(JSON.stringify(json));

    if (json.hours) {
      values.hours = Immutable.List(json.hours).map(hour => new BusinessHour(hour));
    }

    if (json.answers) {
      values.answers = Immutable.List(json.answers);
    }

    super(cleanObject(values));
  }

}